{
  "en": {
    "curriculum": {
      "confirmDelete": {
        "confirm": "Yes, delete",
        "text": "Do you really want to delete \"{filename}\"? The file and its searchable curriculum content will be removed.",
        "title": "Delete curriculum?"
      },
      "confirmedUseful": "Curriculum was confirmed for search.",
      "confirmUseful": "Use for curriculum search",
      "confirmUsefulFailed": "Curriculum could not be confirmed.",
      "configure": "Open curriculum settings",
      "contextPanel": {
        "loadFailed": "The curricula could not be loaded right now. Try again later.",
        "manage": "Manage your own curricula",
        "matching": "These curricula match the school details above.",
        "noSubject": "Select a subject above, then we'll show you matching curricula.",
        "noSubjectMatch": "We don't have any curricula for the selected subject. Upload your own, and the AI will use it.",
        "none": "We don't have a curriculum for these details yet. Upload your own, and the AI will use it.",
        "notFound": "We couldn't find a matching curriculum for the details above in {place}. Upload your own, and the AI will use it.",
        "ownDocument": "Own document",
        "title": "Curricula",
        "unknownRegion": "We don't know your federal state. To prevent the AI from using a wrong curriculum, it won't use one. Add your federal state in your profile.",
        "used": "This material is based on these curricula.",
        "usedIn": "This material is based on these curricula for {place}."
      },
      "coverage": {
        "covered": "covered",
        "grades": "Grade {range}",
        "heading": "Your subjects in {place}",
        "headingWithoutPlace": "Your subjects",
        "notCovered": "not covered",
        "openProfile": "Open profile",
        "profileIncomplete": "Add your subjects, school type, and grade levels to your profile, and we'll show you the matching curricula here.",
        "tooltip": {
          "covered": "For example {example}",
          "coveredMore": "For example {example} and more",
          "notCovered": "We don't have an official curriculum for {place} yet. Upload your own and the AI will use it.",
          "otherRegions": "We don't have an official curriculum for {place} yet, only for other states. Upload your own and the AI will use it."
        },
        "unmapped": "There is no curriculum for {labels}. Upload your own, and the AI will use it."
      },
      "delete": "Delete curriculum",
      "deleted": "Curriculum was deleted.",
      "deleteFailed": "Curriculum could not be deleted.",
      "empty": "No personal curriculum documents have been uploaded yet.",
      "documentKindDescriptions": {
        "cross_curricular_framework": "A cross-curricular framework, for example for media education or digital competencies.",
        "curriculum_guidance": "A guide, commentary, or support material for working with a curriculum.",
        "general_curriculum_part": "A general curriculum part without one specific subject, for example principles or cross-cutting goals.",
        "non_curriculum": "This file was detected as not being a curriculum document.",
        "presentation_or_training_material": "Presentation or training material about curricula, but not the actual curriculum.",
        "subject_curriculum": "A subject-specific curriculum or subject requirements for one concrete school subject.",
        "unknown": "The document type could not be detected reliably."
      },
      "documentKindLabels": {
        "cross_curricular_framework": "Framework",
        "curriculum_guidance": "Guidance",
        "general_curriculum_part": "General curriculum part",
        "non_curriculum": "Not a curriculum",
        "presentation_or_training_material": "Presentation / training",
        "subject_curriculum": "Subject curriculum",
        "unknown": "Unclear"
      },
      "fields": {
        "country": "Country",
        "documentKind": "Document type",
        "gradeLevel": "Grade level",
        "region": "Region",
        "schoolType": "School type",
        "subject": "Subject",
        "title": "Title"
      },
      "hints": {
        "customCategoryValue": "Not found? Enter your own value."
      },
      "intro": "We use the official curricula from Germany, Austria and Switzerland. You can also upload your own curriculum documents, for example a school-internal curriculum. The AI takes them into account together with the official curricula.",
      "loading": "Loading curricula...",
      "needsReview": "We could not clearly assign this document to a curriculum, subject, grade level, or school type. It is probably only partially useful for curriculum search. Please complete the metadata or delete the file.",
      "notSet": "Not set",
      "placeholders": {
        "selectOrAddOptions": "Search, select, or enter your own value"
      },
      "saved": "Curriculum metadata saved.",
      "states": {
        "classification_failed": "Automatic classification failed",
        "classifying": "Curriculum is being analyzed",
        "file_processing_failed": "File could not be read",
        "import_failed": "Import failed",
        "indexing": "Being added to curriculum search",
        "needs_review": "Review needed",
        "official": "Official curriculum",
        "processing_file": "File is being processed",
        "searchable": "Searchable"
      },
      "statusDescriptions": {
        "classification_failed": "Automatic classification could not reliably detect subject, grade level, or school type. You can edit the metadata manually.",
        "classifying": "The curriculum text is being analyzed so subject, grade level, and school type can be suggested.",
        "file_processing_failed": "The file could not be read. Please upload a different PDF, DOCX, or text file.",
        "import_failed": "The curriculum could not be added to curriculum search. You can review the metadata and save it again.",
        "indexing": "The file was classified and is being prepared for curriculum search.",
        "needs_review": "The file was processed, but the curriculum metadata is unclear or incomplete.",
        "official": "Official curriculum data is available for this area.",
        "processing_file": "The file is being read and its text is being extracted.",
        "searchable": "The curriculum is indexed and can be used by curriculum search."
      },
      "title": "Curricula",
      "upload": "Upload curriculum",
      "uploaded": "Curriculum was uploaded and is being processed.",
      "uploadFailed": "Curriculum could not be uploaded."
    }
  }
}
